import React, {useCallback, useEffect} from 'react';
import {useDispatch} from "react-redux";
import {
    UserDropdown,
    ListPage,
    filterConstants,
    accessConstants,
    LessonDropdown,
    ChallengeDropdown,
    catchQueryFilters,
    DatePicker
} from "mindsets-js-sdk";

import Table from "./Table";
import {LoadedVotesAction, LoadVotesAction} from "../../actions/vote_actions";


export default function () {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(LoadedVotesAction([]))
        }
    }, []);

    const actionDebounced = useCallback(_.debounce(a => a(), 600), []);

    function action(options) {
        return LoadVotesAction(Object.assign({
            'selectors[0]': 'user',
            'selectors[1]': 'lesson_challenge_code',
            'selectors[2]': 'poll_poll_options',
        }, options));
    }

    return (
        <>
            <h1>Student Poll Votes</h1>
            <ListPage
                action={action}
                filter_columns={[
                    {
                        key: 'id',
                        name: 'ID',
                        expressions: [
                            filterConstants.EXPRESSION_EQUAL,
                            filterConstants.EXPRESSION_NOT_EQUAL,
                            filterConstants.EXPRESSION_LT,
                            filterConstants.EXPRESSION_LTE,
                            filterConstants.EXPRESSION_GT,
                            filterConstants.EXPRESSION_GTE,
                        ]
                    },
                    {
                        key: 'stream_id',
                        name: 'Stream ID',
                        expressions: [
                            filterConstants.EXPRESSION_EQUAL,
                            filterConstants.EXPRESSION_NOT_EQUAL,
                            filterConstants.EXPRESSION_LT,
                            filterConstants.EXPRESSION_LTE,
                            filterConstants.EXPRESSION_GT,
                            filterConstants.EXPRESSION_GTE,
                        ]
                    },
                    {
                        key: 'user_id',
                        name: 'Student',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: (setFilterValue, index) => {
                            const filters = catchQueryFilters();
                            const district_id_filter = filters.find(filter => filter.column === 'district_id');
                            const school_id_filter = filters.find(filter => filter.column === 'school_id');
                            const country_filter = filters.find(filter => filter.column === 'country');
                            const state_filter = filters.find(filter => filter.column === 'state');
                            const lesson_id_filter = filters.find(filter => filter.column === 'lesson_id');
                            const filter = filters[index];

                            return (
                                <UserDropdown
                                    id='votes-student'
                                    onSelect={user => {
                                        if (user) {
                                            setFilterValue(user.id);
                                        } else {
                                            setFilterValue('');
                                        }

                                        return user ? user.fname + ' ' + user.lname : '';
                                    }}
                                    persona='student'
                                    district_id={district_id_filter && district_id_filter.value ? parseInt(district_id_filter.value) : null}
                                    school_id={school_id_filter && school_id_filter.value ? parseInt(school_id_filter.value) : null}
                                    country={country_filter && country_filter.value ? country_filter.value : null}
                                    state={state_filter && state_filter.value ? state_filter.value : null}
                                    lesson_id={lesson_id_filter && lesson_id_filter.value ? parseInt(lesson_id_filter.value) : null}
                                    debounce={actionDebounced}
                                    show_counts={true}
                                    userId={filter && filter.value ? filter.value : null}
                                />
                            );
                        },
                        multiple: false
                    },
                    {
                        key: 'lesson_id',
                        name: 'Class',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: (setFilterValue, index) => {
                            const filters = catchQueryFilters();
                            const challenge_code_id_filter = filters.find(filter => filter.column === 'challenge_code_id');
                            const district_id_filter = filters.find(filter => filter.column === 'district_id');
                            const school_id_filter = filters.find(filter => filter.column === 'school_id');
                            const country_filter = filters.find(filter => filter.column === 'country');
                            const state_filter = filters.find(filter => filter.column === 'state');
                            const filter = filters[index];

                            return (
                                <LessonDropdown
                                    onSelect={lesson => {
                                        if (lesson) {
                                            setFilterValue(lesson.id);

                                        } else {
                                            setFilterValue('');
                                        }

                                        return lesson ? lesson.code : '';
                                    }}
                                    id='responses-lesson-filter'
                                    challenge_code_id={challenge_code_id_filter && challenge_code_id_filter.value ? parseInt(challenge_code_id_filter.value) : null}
                                    district_id={district_id_filter && district_id_filter.value ? parseInt(district_id_filter.value) : null}
                                    school_id={school_id_filter && school_id_filter.value ? parseInt(school_id_filter.value) : null}
                                    country={country_filter && country_filter.value ? country_filter.value : null}
                                    state={state_filter && state_filter.value ? state_filter.value : null}
                                    debounce={actionDebounced}
                                    show_counts={true}
                                    lessonId={filter && filter.value ? filter.value : null}
                                />
                            );
                        },
                        multiple: false,
                        depends_on: 'challenge_code_id'
                    },
                    {
                        key: 'challenge_code_id',
                        name: 'Challenge',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: (setFilterValue, index) => {
                            const filters = catchQueryFilters();
                            const filter = filters[index];

                            return (
                                <ChallengeDropdown
                                    onSelect={challenge_version => {
                                        if (challenge_version) {
                                            setFilterValue(challenge_version.challenge_code_id);
                                        } else {
                                            setFilterValue('');
                                        }

                                        return challenge_version ? challenge_version.name : '';
                                    }}
                                    id='responses-challenge-filter'
                                    debounce={actionDebounced}
                                    challengeCode={filter && filter.value ? filter.value : null}
                                />
                            );
                        },
                        multiple: false
                    },
                    {
                        key: 'created_at',
                        name: 'Created At',
                        expressions: [filterConstants.EXPRESSION_GT, filterConstants.EXPRESSION_GTE, filterConstants.EXPRESSION_LT, filterConstants.EXPRESSION_LTE],
                        component: (setFilterValue, index) => {
                            const filters = catchQueryFilters();
                            const filter = filters[index];

                            let date = new Date();
                            if (filter && filter.value) {
                                date = new Date(filter.value);
                            }
                            const timestamp = date.getTime();

                            return (
                                <DatePicker
                                    date={timestamp / 1000}
                                    onChange={timestamp => {
                                        const dateFrom = new Date(timestamp * 1000);
                                        const date = dateFrom.toISOString();

                                        setFilterValue(date);
                                    }}/>
                            );
                        },
                    },
                    {
                        key: 'with_trashed',
                        name: 'Include deleted',
                        expressions: [filterConstants.EXPRESSION_TRUE, filterConstants.EXPRESSION_FALSE]
                    }
                ]}
                sort_columns={[
                    {
                        key: 'id',
                        name: 'ID'
                    },
                    {
                        key: 'user_id',
                        name: 'Student ID'
                    }
                ]}
                entity={'votes'}
                permissions={[accessConstants.PERMISSION_CAN_SEE_ALL_STREAMS]}
                default_order_direction={'desc'}
            >
                <Table/>
            </ListPage>
        </>
    );
}
